module.exports = __webpack_public_path__ + "static/img/16021B_1_2_C_20240319_LC.6480be0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/16021B_1_2_C_20240319_LC.png
// module id = sb13
// module chunks = 0